module.exports={
    server: {
        protocol: "https",
        host: "prod.swiss-skills.ch",
        basePath: "/core"   // /core or /proxy
    },
}
